import { Injectable } from '@angular/core';

import { NotificationService } from '@progress/kendo-angular-notification';

import { TranslationService } from './translation.service';
import { NotificationBodyService } from '../notification-body/notification-body.service';

@Injectable()
export class TranslatedNotificationService {

    constructor(
        private translateService: TranslationService,
        private notificationService: NotificationService,
        private notificationBody: NotificationBodyService
    ) { }

    public showMsgError(template: string, originalText: string) {
        this.translateService.translate(template, originalText)
        .then(msg => {
            if (msg) {
                this.notificationService.show(this.notificationBody.error(msg));
            } else {
                this.notificationService.show(this.notificationBody.error(originalText));
            }
        });
    }

    public showMsgSuccess(template: string, originalText: string) {
        this.translateService.translate(template, originalText)
        .then(msg => {
            if (msg) {
                this.notificationService.show(this.notificationBody.success(msg));
            } else {
                this.notificationService.show(this.notificationBody.success(originalText));
            }
        });
    }

    public showMsgInfo(template: string, originalText: string) {
        this.translateService.translate(template, originalText)
        .then(msg => {
            if (msg) {
                this.notificationService.show(this.notificationBody.info(msg));
            } else {
                this.notificationService.show(this.notificationBody.info(originalText));
            }
        });
    }

    public showExceptionError(error: any): any {
        if (error.Data) {
            const template = Object.keys(error.Data)[0];
            const originalText = error.Data[template];

            if (template && originalText) {
                this.translateService.translate(template, originalText)
                    .then(msg => {
                        if (msg) {
                            this.notificationService.show(this.notificationBody.error(msg));
                        } else {
                            this.notificationService.show(this.notificationBody.error(originalText));
                        }
                    });
            } else {
                this.showMsgError('error.error_occurred', 'Error occurred');
            }
        }
        this.showMsgError('error.error_occurred', 'Error occurred');
    }
}
